import React from 'react';
import { Heart, Sparkles, PawPrint } from 'lucide-react';
import { siteData } from '../data/siteData';
import { Card, CardContent } from './ui/card';

const iconMap = {
  Heart: Heart,
  Rainbow: Sparkles,
  PawPrint: PawPrint,
  Sparkles: Sparkles,
};

const Values = () => {
  return (
    <section id="nosotros" className="py-16 sm:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12 sm:mb-16">
          <span className="inline-block px-4 py-1.5 bg-[var(--color-cyan)]/10 text-[var(--color-cyan)] text-sm font-medium rounded-full mb-4">
            Nuestra Filosofía
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[var(--text-primary)] mb-4">
            Más que una peluquería
          </h2>
          <p className="text-lg text-[var(--text-secondary)] max-w-2xl mx-auto">
            {siteData.business.description}
          </p>
        </div>

        {/* Values Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {siteData.values.map((value, index) => {
            const IconComponent = iconMap[value.icon] || Heart;
            const colors = [
              { bg: 'bg-[var(--color-magenta)]/10', text: 'text-[var(--color-magenta)]', border: 'hover:border-[var(--color-magenta)]/30' },
              { bg: 'bg-[var(--color-cyan)]/10', text: 'text-[var(--color-cyan)]', border: 'hover:border-[var(--color-cyan)]/30' },
              { bg: 'bg-[var(--color-orange)]/10', text: 'text-[var(--color-orange)]', border: 'hover:border-[var(--color-orange)]/30' },
              { bg: 'bg-[var(--color-purple)]/10', text: 'text-[var(--color-purple)]', border: 'hover:border-[var(--color-purple)]/30' },
            ];
            const color = colors[index % colors.length];

            return (
              <Card
                key={value.id}
                className={`group border-2 border-transparent ${color.border} transition-all duration-300 hover:shadow-lg hover:-translate-y-1`}
              >
                <CardContent className="p-6">
                  <div className={`w-14 h-14 ${color.bg} rounded-2xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300`}>
                    <IconComponent className={`w-7 h-7 ${color.text}`} />
                  </div>
                  <h3 className="text-xl font-semibold text-[var(--text-primary)] mb-2">
                    {value.title}
                  </h3>
                  <p className="text-[var(--text-secondary)] text-sm leading-relaxed">
                    {value.description}
                  </p>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Values;
